module.exports = {
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/p-death-bomb enem1_.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/p-death-bomb enem2_.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/p-death-bomb enem3_.png").default
        },
        {
            "time": 300,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/p-death-bomb enem4_.png").default
        },
        {
            "time": 400,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/p-death-bomb enem5_.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/p-death-bomb enem6_.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/p-death-bomb enem7_.png").default
        },
        {
            "time": 700,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/p-death-bomb enem8_.png").default
        },
        {
            "time": 800,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/p-death-bomb enem9_.png").default
        },
        {
            "time": 900,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/p-death-bomb enem10_.png").default
        },
        {
            "time": 1000,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-death-bomb enem/p-death-bomb enem11_.png").default
        },
        {
            "time": 1100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/empty_.png").default
        }
    ]
}
